// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"iL","logoWrapper":"iM"};